import React from 'react'

import BButton from 'components/Form/Fields/BButton'
import TotalPrice from 'modules/Checkout/TotalPrice'
import priceParser from 'utils/priceParser'

const SummaryItem = ({t}) => (
  <div>
    <span><b>1x</b> Hamilton Perfection Roller Hamilton Perfection Roller Hamilton Perfection Roller</span>
    <i>Category <b>Building material</b></i>
    <b>{priceParser(4242.42)}</b>
  </div>
)

const Checkout2 = ({t, next, back}) => (
  <div id='checkout2'>
    <h1>{t('Delivery & Billing information')}</h1>

    <div>
      <div>
        <div>
          <h6>{t('Delivery information')}</h6>
        </div>

        <div>
          <h6>{t('Biling information')}</h6>
        </div>

        <BButton ghost onClick={back}>{t('back to step 1')}</BButton>
        <BButton yellow onClick={next}>{t('continue to')} <b>{t('step 2')}</b></BButton>
      </div>

      <div>
        <div>
          <h6>{t('Summary')}</h6>

          <div className='checkout2-summaryItems'>
            <SummaryItem t={t}/>
            <SummaryItem t={t}/>
            <SummaryItem t={t}/>
            <SummaryItem t={t}/>
            <SummaryItem t={t}/>
          </div>

          <TotalPrice t={t}/>
        </div>
      </div>
    </div>
  </div>
)

export default Checkout2
